import '../../styles/globals.css'
import Logo from '../../images/dna_saude.png'

function Footer(){
    return (
        /*<footer className="footer">
            <div className="container">
                <img src={Logo} alt="DNA Saúde" style={{height: '60px', marginBottom: '30px'}}/>
                <div className="footer-links">
                    <a href="#">Termos de Uso</a>
                    <a href="#">Política de Privacidade</a>
                    <a href="#">Dúvidas Frequentes</a>
                    <a href="#">Rede Credenciada</a>
                    <a href="#">Contato</a>
                </div>
                <p className="copyright">© 2025 Corretora DNA Saúde. Todos os direitos reservados.</p>
            </div>
        </footer>*/
        <footer className="footer">
            <div className="container">
                <img src={Logo} alt="DNA Saúde" style={{height: '60px', marginBottom: '30px'}}/>
                <p className="copyright">© 2025 Corretora DNA Saúde. Todos os direitos reservados.</p>
            </div>
        </footer>
    );
}
export default Footer;